var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-message',{attrs:{"type":"is-dark","has-icon":""}},[_c('h3',{staticClass:"subtitle is-5"},[_vm._v(_vm._s(_vm.header))]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.message)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-702f97ee","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/features/Message.vue
// module id = null
// module chunks = 